<div
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  class="relative flex gap-2 flex-col"
>
  @if (agentMarkerLabel()) {
    <flx-ai-chat-agent-marker [label]="agentMarkerLabel()" />
  }
  <div class="flex w-full items-center gap-2">
    @if (showUpload()) {
      <button
        [disabled]="isUploadDisabled()"
        [pTooltip]="uploadFileTooltip()"
        (click)="fileContextInput.click()"
        class="group cursor-pointer disabled:cursor-not-allowed"
        tooltipPosition="top"
        tooltipStyleClass="ai-chat-upload-file-tooltip"
      >
        <flx-icon
          name="paperclip"
          class="text-white group-disabled:text-neutral-400"
        />
      </button>

      <input
        #fileContextInput
        [accept]="allowedFileTypes()"
        [multiple]="isMultipleUploadAllowed()"
        (change)="onFileSelected($event)"
        class="hidden peer"
        type="file"
      />
    }

    <textarea
      #textarea
      [placeholder]="hint()"
      [formControl]="typeControl"
      (keydown)="filterKeyEvents($event)"
      (paste)="onPaste($event)"
      class="w-full mr-6 min-h-6 max-h-[300px] placeholder:px-1 bg-transparent text-sm/6 text-white placeholder-opacity-40 disabled:cursor-not-allowed outline-none"
      cdkTextareaAutosize
    ></textarea>

    <flx-ai-shortcut
      [icons]="submitShortcut"
      [bgClass]="canSubmitPrompt() ? 'bg-neutral-100 group-hover/shortcut:bg-neutral-50' : null"
      [ngClass]="{ 'opacity-30': !canSubmitPrompt() }"
      [pTooltip]="promptInvalidLengthMsg"
      [tooltipDisabled]="!promptInvalidLengthMsg"
      (click)="submitTypeControl()"
      class="group/shortcut cursor-pointer pointer-events-auto"
      tooltipStyleClass="tooltip-error"
      tooltipPosition="top"
    ></flx-ai-shortcut>
  </div>
</div>
